<template>
    <div class="sidebar-left" :class="[SIDE_MENU == 1 ? 'opensidebar':'closesidebar' ]">
      <ToolbarIcon/>
      <div class="sidebar-body scroll-pane">
        <div class="side-nav">
          <div
            v-for="(menuItems, index) in menu"
            :key="index"
            class="menu-group"
          >
            <router-link
              v-for="(item, index1) in menuItems"
              :key="index1"
              :to="item.route"
              class="menu-item"
              @click.native="Toggle"
            >
              <font-awesome-icon :icon="item.icon" class="icon menu-icon" /> <span class="ml-3 menu-text">{{ $t(item.title) }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </template>

  <script type="text/babel">
    import {mapActions, mapGetters} from "vuex";
    import ToolbarIcon from "./ToolbarIcon";

  export default {
    components: {ToolbarIcon},
    data () {
        return {
          sidebar: 'sidebar',
          menu: [

            // [
            //   {
            //     title: 'navigation.dashboard',
            //     icon: 'tachometer-alt',
            //     route: '/auditor/dashboard'
            //   },
            // ],
            [
              {
                title: 'navigation.islamic_finance',
                icon: 'shopping-bag',
                route: '/auditor/islamic-finances'
              }
            ],
          ]
        }
      },
    created () {},
      computed: {
        ...mapGetters('general', [
          'SIDE_MENU'
        ]),
      },
      methods: {
        Toggle () {
          this.$utils.toggleSidebar()
        }
      }
    }
  </script>

